import BetBonusShow from './bet-bonus.show';
import BetBonusList from './bet-bonus.list';

export default {
  show: BetBonusShow,
  list: BetBonusList,
};
